import React from 'react';

function Spacer() {
  return (
    <div className="spacer">
      <div className="spacer__line"></div>
      <div className="spacer__particles">
        <div className="spacer__particle"></div>
        <div className="spacer__particle"></div>
        <div className="spacer__particle"></div>
      </div>
    </div>
  );
}

export default Spacer;